// extracted by mini-css-extract-plugin
export default {"aaa":"Spinner_aaa__rO2nT","loader":"Spinner_loader__GQ3jW","coin-flip":"Spinner_coin-flip__7tmTI"};